import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-item-wish-list',
	templateUrl: './item-wish-list.component.html',
	styleUrls: ['./item-wish-list.component.css']
})
export class ItemWishListComponent implements OnInit {

	@Input() newInventarioDetalle:any = {};

	constructor( private newRouter:Router ) { }

	ngOnInit(): void {
	}

	fnInformacionProducto(){
        var identificador =  `${this.newInventarioDetalle["sku"]} ${this.newInventarioDetalle["alias"]}`;
        this.newRouter.navigate([ '/producto', encodeURI(identificador) ]);
    }

    fnGetImage(){
    	if( this.newInventarioDetalle.fotografia ){
    		return this.newInventarioDetalle.fotografia;
    	}else{
    		return "assets/images/sinFotografia.png";
    	}
    }


}
